import { API } from '../../utils';
import { IParams } from '../types';
import { GW_SERVICES_PREFIXES } from '../../constants';

const { C300, REQUEST } = GW_SERVICES_PREFIXES;

/*Запрос материалов*/
export const GetMaterials = (params: IParams) =>
  API.get(`/${C300}/models/catalogue/materials/`, undefined, params);

/*Запрос услуг*/
export const GetServices = (params: IParams) =>
  API.get(`/${C300}/models/catalogue/services/`, undefined, params);

/*Запрос складов*/
export const GetWareHouses = () => API.get(`/${C300}/models/warehouses/`);

/*Запрос материалов по складу*/
export const GetMaterialBalance = (params: IParams) =>
  API.get(`/${C300}/warehouse/material_balance/`, undefined, params);

/*Запрос единиц измерения*/
export const GetUnits = () => API.get(`/${C300}/models/units/`);

/*Список сервисов каталога ссылок */
export const GetLinksCatalogueServices = (params?: IParams) =>
  API.get(`/${C300}/models/links_catalogue/services/`, undefined, params);

/*Создание сервиса каталога ссылок */
export const CreateLinksCatalogueService = (params: IParams) =>
  API.gatewayPost(`/${C300}/models/links_catalogue/services/`, params);

/*Удаление сервиса каталога ссылок */
export const DeleteLinksCatalogueService = (id: string) =>
  API.delete(`/${C300}/models/links_catalogue/services/`, id);

/*Изменение сервиса каталога ссылок */
export const UpdateLinksCatalogueService = (id: string, params: IParams) =>
  API.gatewayPatch(`/${C300}/models/links_catalogue/services/`, id, params);
